import Service from "../../services";
import { checkAndReturn } from "../../main";

const state = {};

const getters = {};

const actions = {
  index({ commit }, params) {
    return Service.USPExtend.index(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  show({ commit }, params) {
    return Service.USPExtend.show(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  create({ commit }, params) {
    return Service.USPExtend.create(params.payload).then((res) => {
      return checkAndReturn(params, res);
    });
  },

  store({ commit }, data) {
    return Service.USPExtend.store(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  edit({ commit }, data) {
    return Service.USPExtend.edit(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  update({ commit }, data) {
    return Service.USPExtend.update(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  delete({ commit }, data) {
    return Service.USPExtend.delete(data.payload).then((res) => {
      return checkAndReturn(data, res);
    });
  },

  updatePendingFormStatus ({ commit }, data) {
    return Service.USPExtend.updatePendingFormStatus(data.payload).then(res => {
        return checkAndReturn(data, res)
    })
},

};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
